import React from "react";
import { ContainerComponent, wrap } from 'AppReact';
import Schema from 'AppReact/schema';
import Controller from './controller';
import { UploadWrapper } from '../wrappers';
import { UploadButton, UploadedImage } from 'molecules';
import { optionaldocsSechema, defaultOptionalDocs } from "../../../../types";
import { WebCamBtn } from "../atoms";
import { SubsectionHeader } from "../../../../common/molecules";
import { FieldWrapper, MarginY10 } from "../../../../common/wrappers";
import { FlexCenterJustifyCenterWrapper } from "wrappers";
import { InputError } from 'molecules';


const CameraIcon = () => <i className="fas fa-camera-retro fa-3x cursor-pointer" />
const WrappedInputError = wrap(InputError, FieldWrapper)

const Documents = ({
    controller: Controller,
    name: "OptionalDoc",
    initialProps: ({ doc, docs, sectionaLabel, buttonLabel, toggleWebCam, selectedTabId }) => ({ doc, docs, sectionaLabel, buttonLabel, toggleWebCam, selectedTabId }),
    props: {
        doc: Schema(optionaldocsSechema, 'object', { defaultValue: defaultOptionalDocs }),
        docs: Schema(optionaldocsSechema, 'array'),
        sectionaLabel: Schema('string', 'primitive'),
        buttonLabel: Schema('string', 'primitive'),
        toggleWebCam:Schema('string', 'primitive'),
        selectedTabId: Schema('string', 'primitive'),

    },
    elements: [
        {
            wrapper: MarginY10,
            name: 'Wrapper',
            elements: [
                {
                    component: SubsectionHeader,
                    name: 'DeleteButton',
                    renderIf: ({ doc, toggleWebCam }) => doc?.id !== '1' && toggleWebCam !== 'photoID',
                    bindings: ({ docs, doc, sectionaLabel }) => ({ docs, label: sectionaLabel ?? "Upload Section", id: doc?.id })
                },
                {
                    wrapper: UploadWrapper,
                    name: 'OptionalUpload',
                    elements: [
                        {
                            component: UploadButton,
                            name: 'UploadButton',
                            displayValue: ({ }) => "",
                            bindings: ({ doc, docs, buttonLabel }) => ({ doc, docs, label: '', text: buttonLabel ?? "Upload" })
                        },
                        {
                            component: WebCamBtn,
                            name: "OptionalWebCamBtn",
                            renderIf: ({ doc }) => !doc.docUrl,
                            displayValue: ({ }) => <CameraIcon />,
                            bindings: ({ doc, toggleWebCam }) => ({ toggleWebCam, docID: doc.id })
                        },
                        {
                            component: UploadedImage,
                            name: 'UploadedImage',
                            renderIf: ({ doc }) => !!doc.docUrl,
                            displayValue: ({ }) => null,
                            bindings: ({ doc, docs }) => ({ doc, docs, src: doc.docUrl || '' })
                        }
                    ]
                },
                {
                    component: wrap(WrappedInputError, FlexCenterJustifyCenterWrapper),
                    name: 'UploadedPayStubError',
                    bindings: ({ doc }) => ({ error: doc?.docIDError ?? "Something went wrong"}),
                    renderIf: ({ doc, selectedTabId }) => !!doc?.docIDError && selectedTabId !== 'review',
                },
            ]
        },
    ],
})

export default ContainerComponent(Documents);
